"use strict";
exports.__esModule = true;
exports["default"] = (function (a) {
    return process.env[a].toLowerCase() === 'true';
});
